import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DispatcherComponent } from './dispatcher/dispatcher.component';
import { DispatcherHomeComponent } from './dispatcher/dispatcherhome/dispatcherhome.component';
import { TasksComponent } from './dispatcher/tasks/tasks.component';
import { AccountComponent } from './dispatcher/account/account.component';
import { WalletComponent } from './dispatcher/wallet/wallet.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'dispatcher',
    component: DispatcherComponent,
    children: [
      { path: '', redirectTo: 'dispatcherhome', pathMatch: 'full' },
      { path: 'dispatcherhome', component: DispatcherHomeComponent },
      { path: 'tasks', component: TasksComponent },
      { path: 'account', component: AccountComponent },
      { path: 'wallet', component: WalletComponent }
    ]
  }
];

export const routing = RouterModule.forRoot(routes, { useHash: true });
